import React from "react";
import { Warning, Hourglass, CheckCircle } from "@phosphor-icons/react";

const STYLE = {
    breached: { color: "#B91C1C", bg: "#FEE2E2", border: "#FCA5A5", Icon: Warning, label: "SLA breach" },
    at_risk: { color: "#B45309", bg: "#FEF3C7", border: "#FCD34D", Icon: Hourglass, label: "SLA at risk" },
    on_track: { color: "#15803D", bg: "#DCFCE7", border: "#86EFAC", Icon: CheckCircle, label: "On track" },
    not_applicable: { color: "#71717A", bg: "#F4F4F5", border: "#E4E4E7", Icon: null, label: "No SLA" },
};

function fmtHours(h) {
    const v = Math.abs(h);
    if (v < 24) return `${Math.round(v)}h`;
    return `${Math.floor(v / 24)}d ${Math.round(v % 24)}h`;
}

export default function SlaBadge({ sla, size = "sm", showLabel = false, testid }) {
    if (!sla || !sla.applicable) return null;
    const meta = STYLE[sla.risk] || STYLE.on_track;
    const Icon = meta.Icon;
    const padding = size === "lg" ? "px-2.5 py-1" : "px-1.5 py-0.5";
    const textSize = size === "lg" ? "text-[11px]" : "text-[10px]";
    let text;
    if (sla.breach) {
        text = `${fmtHours(sla.breach_severity_hours)} over SLA`;
    } else {
        text = `${fmtHours(sla.hours_remaining)} left`;
    }
    return (
        <span
            data-testid={testid || `sla-${sla.risk}`}
            className={`inline-flex items-center gap-1 font-mono ${textSize} uppercase tracking-wider ${padding}`}
            style={{ color: meta.color, backgroundColor: meta.bg, border: `1px solid ${meta.border}` }}
            title={`${sla.stage} stage · SLA ${sla.sla_hours}h · in stage ${fmtHours(sla.hours_in_stage)}`}
        >
            {Icon && <Icon size={size === "lg" ? 12 : 10} weight="bold" />}
            {showLabel && <span>{meta.label}</span>}
            <span>{text}</span>
        </span>
    );
}
